import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.mobile} 20px;
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;

  > h1 {
    color: #2d2d2d;
    text-align: center;
    font-family: Mulish;
    font-size: 20px;
    font-style: normal;
    font-weight: 800;
    line-height: 30px;
    letter-spacing: 0.6px;
    margin-bottom: 32px;
  }

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const WrapperFilter = styled.div`
  gap: 32px 16px;
  margin-bottom: 24px;
  justify-content: end;
  flex-wrap: wrap;

  @media (min-width: 640px) {
    justify-content: start;
    margin: 0 auto 32px;
  }
`;

export const ItemMobile = styled.div`
  padding: 8px 16px;
  border-radius: 5px;
  display: flex;
  height: fit-content;
  justify-content: space-between;
`;

export const TableElement = styled.p`
  color: #2d2d2d;
  font-size: 12px;
  font-style: normal;
  font-weight: 800 !important;
  line-height: 24px;
  letter-spacing: 0.36px;
  text-transform: uppercase;
  display: flex;
  gap: 4px;

  > span {
    color: #595959;
    font-weight: 400;
  }
`;

export const WrapperButons = styled.div`
  width: fit-content;
  display: flex;
  gap: 16px;
  margin: 0 auto 32px;

  @media (min-width: 640px) {
    margin: 0 0 32px;
  }
`;
